export enum GameStatus {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    RaceOff = "RaceOff",
    Resulted = "Resulted"
}